import { FormattedMessage } from 'react-intl'

import { SearchIcon } from 'Icons'
type MobileSearchButtonProps = {  onClick: () => void
}

export default function MobileSearchButton({ onClick }: MobileSearchButtonProps) {
  return (
    <button tabIndex={0} className="btn btn-sm font-sans dark:hover:bg-slate-950" onClick={onClick}>
      <SearchIcon />
      <FormattedMessage id="input.search" defaultMessage="Search" />
    </button>
  )
}
